/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  GetTerminalDto,
  TerminalDiagnosisRequestDto,
  TerminalStatusResponse,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    GetTerminalDtoFromJSON,
    GetTerminalDtoToJSON,
    TerminalDiagnosisRequestDtoFromJSON,
    TerminalDiagnosisRequestDtoToJSON,
    TerminalStatusResponseFromJSON,
    TerminalStatusResponseToJSON,
} from '../models';

export interface GetTerminalRequest {
    pspTerminalId: string;
    locationId: string;
}

export interface GetTerminalsRequest {
    ids: Array<string>;
    locationId: string;
}

export interface SendDiagnosisRequestRequest {
    locationId: string;
    pspTerminalId: string;
}

/**
 * 
 */
export class TerminalControllerApi extends runtime.BaseAPI {

    /**
     */
    async getTerminalRaw(requestParameters: GetTerminalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminalStatusResponse>> {
        if (requestParameters.pspTerminalId === null || requestParameters.pspTerminalId === undefined) {
            throw new runtime.RequiredError('pspTerminalId','Required parameter requestParameters.pspTerminalId was null or undefined when calling getTerminal.');
        }

        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/locations/{locationId}/terminals/{pspTerminalId}/status`.replace(`{${"pspTerminalId"}}`, encodeURIComponent(String(requestParameters.pspTerminalId))).replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTerminal(requestParameters: GetTerminalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminalStatusResponse> {
        const response = await this.getTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTerminalsRaw(requestParameters: GetTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTerminalDto>>> {
        if (requestParameters.ids === null || requestParameters.ids === undefined) {
            throw new runtime.RequiredError('ids','Required parameter requestParameters.ids was null or undefined when calling getTerminals.');
        }

        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getTerminals.');
        }

        const queryParameters: any = {};

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/locations/{locationId}/terminals`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTerminalDtoFromJSON));
    }

    /**
     */
    async getTerminals(requestParameters: GetTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTerminalDto>> {
        const response = await this.getTerminalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendDiagnosisRequestRaw(requestParameters: SendDiagnosisRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminalDiagnosisRequestDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling sendDiagnosisRequest.');
        }

        if (requestParameters.pspTerminalId === null || requestParameters.pspTerminalId === undefined) {
            throw new runtime.RequiredError('pspTerminalId','Required parameter requestParameters.pspTerminalId was null or undefined when calling sendDiagnosisRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/locations/{locationId}/terminals/{pspTerminalId}/diagnosis`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"pspTerminalId"}}`, encodeURIComponent(String(requestParameters.pspTerminalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalDiagnosisRequestDtoFromJSON(jsonValue));
    }

    /**
     */
    async sendDiagnosisRequest(requestParameters: SendDiagnosisRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminalDiagnosisRequestDto> {
        const response = await this.sendDiagnosisRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
